export default {
    OPEN_STATIC: 'OPEN_STATIC',
    REQUESTING: 'REQUESTING',
    SUCCESS: 'SUCCESS',
    CLOSED: 'CLOSED',
};
